import { render, staticRenderFns } from "./bannerAdLists.vue?vue&type=template&id=770c3e77&scoped=true"
import script from "./bannerAdLists.vue?vue&type=script&lang=ts"
export * from "./bannerAdLists.vue?vue&type=script&lang=ts"
import style0 from "./bannerAdLists.vue?vue&type=style&index=0&id=770c3e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c3e77",
  null
  
)

export default component.exports